import(/* webpackMode: "eager" */ "/home/runner/_work/frontends/frontends/apps/sessions/src/app/error.tsx");
